

	import { Component, Prop } from 'vue-property-decorator';
	import { PropType } from 'vue';
	import { BaseView } from '@shared/views/BaseView';
	import { DeckImage, Deck } from '@shared/models';

	@Component({})
	export default class DeckImageView extends BaseView {

		@Prop({ type: Object as PropType<Deck> })
		public model: Deck;
		
		public images: DeckImage[] = [];
		public defaultImage: DeckImage = null;
		public imageUrls: string[] = [];

		public options: any = {
			zoomed: this.onZoom,
			rotate: this.onRotate,
			viewed: this.onViewed,
			hidden: this.onHidden,
		};

		public async mounted() {
			this.images = await this.$api.deckImageService.list(this.model.id);
			
			for (const i of this.images) {
				this.imageUrls.push(i.url);
			}
			

			// // FIND THE DEFAULT IMAGE
			// if (this.images?.length) {
			// 	this.defaultImage = this.images.find((x) => x.isDefault);
			// }

			// IF A DEFAULT IMAGE DOESN'T EXIST, LETS CREATE ONE
			if (!this.defaultImage) {
				this.defaultImage = new DeckImage({
					url: `https://lurker.blob.core.windows.net/decks/d_deck_${this.model.id}.jpg?cb=${Math.random().toString(24)}`,
					altText:  `${this.model.name} ${this.model.year}`,
				});
			} else {
				// A DEFAULT IMAGE DOES EXIST, LETS REMOVE IT FROM THE IMAGE LIST SO WE DON'T DUPLICATE IT
				const defaultIndex = this.images.findIndex((x) => x.id === this.defaultImage.id);
				this.images.splice(defaultIndex, 1);
			}

			for (const img of this.images) {
				if (!img.caption) { 
					img.caption = `${this.model.name} ${this.model.year}`; 
					if (this.model.companies?.length) {
						img.caption += ` by ${this.model.companies[0].name}`;
					}
				}
				if (!img.altText) { img.altText = img.caption; }
			}

		}

		/** Fires when an image in the viewer component is zoomed in. */
		public onZoom(args: any) {
			// const src = args.target.firstChild.firstChild.currentSrc;
			// this.analytics.event('image-viewer', 'decks', 'rotate', src, args.detail.ratio );
		}

		/** Fires when an image in the viewer component is rotated. */
		public onRotate(args: any) {
			// const src = args.target.firstChild.firstChild.currentSrc;
			// this.analytics.event('image-viewer', 'decks', 'rotate', src, args.detail.degree);
		}

		/** Fires when an image in the viewer component is opened. */
		public onViewed(args: any) {
			// const src = args.target.firstChild.firstChild.currentSrc;
			// this.analytics.event('image-viewer', 'decks', 'viewed', src);
		}

		/** Fires when an image in the viewer component is closed. */
		public onHidden(args: any) {
			// const src = args.target.firstChild.firstChild.currentSrc;
			// this.analytics.event('image-viewer', 'decks', 'closed', src);

		}

	}

